import { AsyncPipe, NgFor, NgIf } from '@angular/common';
import { Component } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Observable } from 'rxjs';
import { AppSettings } from 'src/app/models/app-settings';
import { AppSettingsService } from './../../services/app-settings.service';

@Component({
  selector: 'app-help-desk-modal',
  templateUrl: './help-desk-modal.component.html',
  styleUrls: ['./help-desk-modal.component.scss'],
  imports: [AsyncPipe, NgIf, NgFor]
})
export class HelpDeskModalComponent {
  appSettings$: Observable<AppSettings>;

  /**
   * Constructor.
   */
  constructor(
    public appSettingsService: AppSettingsService,
    public modalRef: BsModalRef) {

    this.appSettings$ = this.appSettingsService.getAppSettingsObservable();
  }

  /**
   * Closes the modal in response to the user clicking a close command.
   */
  onCloseClicked(): void {
    this.modalRef.hide();
  }
}
